import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  HostListener,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { environment } from "../../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { NgxLinkifyOptions } from "ngx-linkifyjs";
import { PlayerService } from "../../core/services/player/player.service";

import {
  Show,
  Archive,
  ArchiveCategory,
  ArtistArchiveResponse,
} from "../../../services/archive.model";

@Component({
  selector: "app-artist-shows",
  templateUrl: "./artist-shows.component.html",
  styleUrls: ["./artist-shows.component.scss"],
})
export class ArtistShowsComponent implements OnInit {
  public playerEnabled = !(
    window.location.hostname === environment.iOSAppDomain
  );
  public artistId: string;
  public artistName: string = "";
  public archive: Archive = undefined;
  public isPlaying = false;
  public playingShowId: number = null;
  public loading = true;
  public currentPage: number = 1;
  public isLoadingMore: boolean = false;
  @ViewChild("scrollContainer") scrollContainer: ElementRef;

  constructor(
    private http: HttpClient,
    private playerService: PlayerService,
    private route: ActivatedRoute,
  ) {
    this.playerService.isPlaying.subscribe(
      (isPlaying) => (this.isPlaying = isPlaying),
    );
  }

  public getArtwork(path: string) {
    return "url('" + path + "')";
  }

  public getCatQueryParams(cat: ArchiveCategory) {
    return { [cat.type]: cat.name };
  }

  public linkifyOptions: NgxLinkifyOptions = {
    target: {
      url: "_blank",
    },
    format(value: string, type: string): any {
      if (type === "url") {
        value = value
          .replace("https://", "")
          .replace("http://", "")
          .replace("www.", "");
      }

      return value;
    },
  };

  public play(show: Show) {
    if (!this.isPlaying || this.playingShowId !== show.id) {
      if (this.playingShowId === show.id) {
        this.playerService.play();
      } else {
        this.playingShowId = show.id;
        this.playerService.playFromArchive(show);
      }
    } else {
      this.playingShowId = null;
      this.playerService.pause();
    }
  }

  public otherArtists(show: Show) {
    const artists = show.artists.filter((artist) => artist.id != this.artistId);
    return artists;
  }

  loadArtistShows(page: number = 1): void {
    if (page === 1) {
      this.loading = true;
    } else {
      this.isLoadingMore = true;
    }

    this.http
      .get(
        environment.cmsUrl +
          environment.routes.getArtistArchive +
          "/" +
          this.artistId +
          "?page=" +
          page,
      )
      .subscribe(
        (data: ArtistArchiveResponse) => {
          if (data.status) {
            if (page === 1) {
              this.archive = data.archive;
            } else if (this.archive) {
              // Append new data to existing archive
              this.archive.data = [...this.archive.data, ...data.archive.data];
            }

            this.artistName = data.artistName;
            this.currentPage = page;
            this.loading = false;
            this.isLoadingMore = false;
          } else {
            this.loading = false;
            this.isLoadingMore = false;
          }
        },
        (error) => {
          console.error("Error fetching artist shows:", error);
          this.loading = false;
          this.isLoadingMore = false;
        },
      );
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.artistId = params.get("artistId");
      if (this.artistId) {
        this.loadArtistShows();
      }
    });
  }

  @HostListener("window:scroll", ["$event"])
  onMobileScroll($event) {
    if (window.innerWidth <= 900 && !this.loading && !this.isLoadingMore) {
      const el = $event.target.documentElement;
      if (el.scrollHeight - el.scrollTop <= el.clientHeight + 100) {
        this.loadMoreShows();
      }
    }
  }

  onScroll(event: any): void {
    //console.log("scroll happened", event.target);
    if (this.loading || this.isLoadingMore || window.innerWidth <= 900) {
      return;
    }

    const element = event.target;
    if (
      element.scrollHeight - element.scrollTop <=
      element.clientHeight + 100
    ) {
      this.loadMoreShows();
    }
  }

  loadMoreShows(): void {
    if (
      this.archive &&
      this.archive.data &&
      this.archive.data.length < this.archive.total
    ) {
      this.loadArtistShows(this.currentPage + 1);
    }
  }
}
